import { sidebarStore } from "Components/Core/Sidebar/SidebarStore";
import { MenuItemWithBadge, SubmenuItem } from "Components/Core/Sidebar/subMenus";
import { CoreStore } from "Stores/RESTStore/CoreStore";

type SubMenus = "PRIVATE" | "PUBLIC" | "CALLS_FOR_TENDER";

export const subMenuConfig = {
  get config(): SubmenuItem[] {
    const mainModuleChildren = sidebarStore.menu?.find((m) => m.module === "CONTACTS")?.children;
    const subModules = mainModuleChildren ? (mainModuleChildren.map((m) => m.module) as SubMenus[]) : null;
    const config = [
      {
        label: <MenuItemWithBadge label={`Public`} store={{} as CoreStore} />,
        link: "public",
      },
      {
        label: <MenuItemWithBadge label={`Private`} store={{} as CoreStore} />,
        link: "private",
      },
    ];

    subModules &&
      subModules.includes("CALLS_FOR_TENDER") &&
      config.push({
        label: <MenuItemWithBadge label={`Calls for tenders`} store={{} as CoreStore} />,
        link: "tender",
      });

    return config;
  },
};
